const REA = 0.06;
const zesaTariffBands = {
  first50: {
    tariff: 8.02,
    bandFloor: 0,
    bandCeil: 50,
    bandUnits: 50,
    rea: REA * 0.06,
    combinedTariff: function () {
      return this.tariff * (REA + 1);
    },
    bandNetZWL: function () {
      return this.tariff * this.bandUnits;
    },
    bandREAZWL: function () {
      return REA * this.tariff * this.bandUnits;
    },
    bandNetZWL: function () {
      return this.bandUnits * (this.tariff + this.rea);
      // return Number((this.bandUnits * (this.tariff + this.rea)).toFixed(2));
    },
    bandCombinedZWL: function () {
      return this.combinedTariff() * this.bandUnits;
    },
  },
  secondBand: {
    tariff: 16.08,
    bandFloor: 51,
    bandCeil: 100,
    bandUnits: 50,
    rea: REA,
    combinedTariff: function () {
      return this.tariff * (REA + 1);
    },
    bandNetZWL: function () {
      return this.tariff * this.bandUnits;
    },
    bandREAZWL: function () {
      return REA * this.tariff * this.bandUnits;
    },
    bandNetZWL: function () {
      return this.bandUnits * (this.tariff + this.rea);
      // return Number((this.bandUnits * (this.tariff + this.rea)).toFixed(2));
    },
    bandCombinedZWL: function () {
      return this.combinedTariff() * this.bandUnits;
    },
  },
  thirdBand: {
    tariff: 28.17,
    bandFloor: 101,
    bandCeil: 200,
    bandUnits: 100,
    rea: REA,
    combinedTariff: function () {
      return this.tariff * (REA + 1);
    },
    bandNetZWL: function () {
      return this.tariff * this.bandUnits;
    },
    bandREAZWL: function () {
      return REA * this.tariff * this.bandUnits;
    },
    bandNetZWL: function () {
      return this.bandUnits * (this.tariff + this.rea);
      // return Number((this.bandUnits * (this.tariff + this.rea)).toFixed(2));
    },
    bandCombinedZWL: function () {
      return this.combinedTariff() * this.bandUnits;
    },
  },
  fourthBand: {
    tariff: 40.22,
    bandFloor: 101,
    bandCeil: 300,
    bandUnits: 100,
    rea: REA,
    combinedTariff: function () {
      return this.tariff * (REA + 1);
    },
    bandNetZWL: function () {
      return this.tariff * this.bandUnits;
    },
    bandREAZWL: function () {
      return REA * this.tariff * this.bandUnits;
    },
    bandNetZWL: function () {
      return this.bandUnits * (this.tariff + this.rea);
      // return Number((this.bandUnits * (this.tariff + this.rea)).toFixed(2));
    },
    bandCombinedZWL: function () {
      return this.combinedTariff() * this.bandUnits;
    },
  },
  fifthBand: {
    tariff: 46.22,
    bandFloor: 301,
    bandCeil: 400,
    bandUnits: 100,
    rea: REA,
    combinedTariff: function () {
      return this.tariff * (REA + 1);
    },
    bandNetZWL: function () {
      return this.tariff * this.bandUnits;
    },
    bandREAZWL: function () {
      return REA * this.tariff * this.bandUnits;
    },
    bandNetZWL: function () {
      return this.bandUnits * (this.tariff + this.rea);
      // return Number((this.bandUnits * (this.tariff + this.rea)).toFixed(2));
    },
    bandCombinedZWL: function () {
      return this.combinedTariff() * this.bandUnits;
    },
  },

  finalBand: {
    tariff: 48.24,
    bandFloor: 401,
    bandCeil: "none",
    bandUnits: "∞",
    combinedTariff: function () {
      return this.tariff * (REA + 1);
    },
    bandNetZWL: function () {
      return this.tariff * this.bandUnits;
    },
    bandREAZWL: function () {
      return REA * this.tariff * this.bandUnits;
    },
    bandNetZWL: function () {
      return this.bandUnits * (this.tariff + this.rea);
      // return Number((this.bandUnits * (this.tariff + this.rea)).toFixed(2));
    },
    bandCombinedZWL: function () {
      return this.combinedTariff() * this.bandUnits;
    },
  },
};

export { zesaTariffBands, REA };
